import ctl from '@netlify/classnames-template-literals'
import { ReactNode } from 'react'

export type WidgetSectionMode = 'simple' | 'pro'

export interface WidgetSectionProps {
	children: ({ mode }: { mode: WidgetSectionMode }) => ReactNode
	label: string

	mode?: WidgetSectionMode
	onModeChange?: (mode: WidgetSectionMode) => void
}

export function WidgetSection({ children, label, mode, onModeChange }: WidgetSectionProps) {
	const currentMode = mode ?? 'simple'

	const optionClassName = ctl(`
		text-[10px]
		 px-2 py-0.5 rounded
		cursor-pointer
		hover:translate-y-[-1px]
		active:translate-y-[1px]
		transition-all
		ring
		tracking-wide
	`)

	return (
		<div className="flex flex-col gap-4 mt-6 mb-2">
			<div className="relative">
				<div className="h-[1px] bg-grey-200" />
				<div className="text-xs text-grey-500 absolute top-1/2 -translate-y-1/2 left-2 px-1 bg-white">
					{label}
				</div>
				{mode && (
					<div
						className={ctl(
							`absolute top-1/2 -translate-y-1/2 right-2
							bg-white flex`,
						)}
					>
						{/*  Intentionally commented out as an alt mode */}
						{
							/* <button
							className={ctl(`${optionClassName}
								hover:bg-grey-200
								hover:text-grey-800
								aria-pressed:bg-grey-100
								aria-pressed:text-grey-700`)}
							aria-pressed={currentMode === 'simple'}
							onClick={() => onModeChange?.('simple')}
						>
							Simple
						</button>
						<button
							className={ctl(`${optionClassName}
								hover:bg-brand-200
								hover:text-brand-800
								aria-pressed:bg-brand-100
								aria-pressed:text-brand-700`)}
							aria-pressed={currentMode === 'pro'}
							onClick={() => onModeChange?.('pro')}
						>
							Pro
						</button> */
						}

						<button
							className={ctl(`
								${optionClassName}
								${
								(currentMode === 'pro')
									? 'bg-purple-50 text-purple-700 ring-purple-200 animate-tada'
									: 'bg-white text-grey-500 ring-grey-200'
							}
								flex gap-1 items-center
								`)}
							key={currentMode}
							onClick={() => onModeChange?.(currentMode === 'simple' ? 'pro' : 'simple')}
						>
							{currentMode === 'pro'
								&& (
									<svg
										xmlns="http://www.w3.org/2000/svg"
										fill="none"
										viewBox="0 0 10 10"
										className="text-brand-600"
										height={10}
										width={10}
									>
										<path
											fill="currentColor"
											d="M7 0.5a0.5 0.5 0 0 0 -0.854 -0.354l-5.5 5.5A0.5 0.5 0 0 0 1 6.5h2v3a0.5 0.5 0 0 0 0.854 0.354l5.5 -5.5A0.5 0.5 0 0 0 9 3.5H7v-3Z"
											strokeWidth={1}
										/>
									</svg>
								)}
							{currentMode === 'pro' ? 'Pro' : 'Simple'}
						</button>
					</div>
				)}
			</div>
			<div className="mx-2 mt-2 flex flex-col gap-2">
				{children({ mode: currentMode })}
			</div>
		</div>
	)
}
